module.exports = __webpack_public_path__ + "static/FiraCode-Bold-b7650b06e23141743ae7b56b99fe5c86.woff2";